/*!
 *
 * Copyright 2018 - acrazing
 *
 * @author acrazing joking.young@gmail.com
 * @since 2018-01-06 12=23=01
 * @version 1.0.0
 * @desc constants.ts
 */

export const KeyVersions = '__mobx_sync_versions__';
export const KeyDefaultKey = '__mobx_sync__';
export const KeyActionName = '__PERSIST__';
export const KeyNodeVersion = '__mobx_sync_this__';
export const KeyIgnores = '__mobx_ignores__';
export const KeyFormat = '__mobx_sync_format__';
export const KeyInject = '__mobx_sync_inject__';
